import { EventVisualization } from 'domain/feature/hotsite/EventVisualization'
import React from 'react'
import { useParams } from 'react-router'
import { GetFormat, useGet } from 'sharedKernel/api'

export const HotsiteEventPage = (): JSX.Element => {
  const { eventId } = useParams()

  const request: GetFormat = {
    url: `/v1/hotsite/event/${eventId}`
  }
  const { data: eventData, isFetching: isEventFetching } = useGet<any>(request, 'hotsite-event')

  const filesRequest: GetFormat = {
    url: `/v1/hotsite/event/${eventId}/files`
  }
  const { data: fileData, isFetching: isFileFetching } = useGet<any>(filesRequest, 'hotsite-event-files')

  return (
    <EventVisualization
      isFetching={isEventFetching}
      data={eventData}
      isFileFetching={isFileFetching}
      fileData={fileData?.rows}
    />
  )
}
